import { createSlice } from '@reduxjs/toolkit';

export const questionSlice = createSlice({
  name: 'questionResult',
  initialState: {
    formData: {},
    apiData: {
      Tatal: 0,  // typo, should it be "Total"? check your API spelling
      Listen_Que: [],
      Speek_Que: [],
      Read_Que: [],
      write_Que: []
    },
  },
  reducers: {
    updateResult: (state, action) => {
      state.formData = action.payload;
    },
    saveApiData: (state, action) => {
      state.apiData = action.payload;
    },
  },
});

// Export actions
export const { updateResult, saveApiData } = questionSlice.actions;

// Export reducer
export default questionSlice.reducer;
